import bootbox from 'bootbox';
import _ from 'lodash';
import api from '../../api';
import Maps from './Maps';
import translate from '../../core/tools/translate';
// import 'mapbox.js';

const halo = () => require('../../core/map/halo').default;
const capture = () => require('../../core/map/capture').default;
const streetView = () => require('../../core/map/streetview').default;
const LayerInfo = (name) => require('../../info').get(name);

class Directions extends L.Control {
    constructor (options) {
        super();

        const defaults = {
            color: 'blue',
            endMarkerIcon: new L.Icon.Default(),
            endMarkerLabel: 'End Marker',
            startMarkerIcon: new L.Icon.Default(),
            startMarkerLabel: 'Start Marker'
        };

        this.centerMap = this.centerMap.bind(this);
        this.zoomIn = this.zoomIn.bind(this);
        this.zoomOut = this.zoomOut.bind(this);
        this.removePoints = this.removePoints.bind(this);
        this.active = this.active.bind(this);
        this.setStartPosition = this.setStartPosition.bind(this);
        this.setEndPosition = this.setEndPosition.bind(this);
        this.options = _.assign({}, defaults, options);
        this._map = this.options.map;
        if (this._map instanceof Maps) {
            this._route = new Map();
        }
    }

    getRoute () {
        const defaults = {
            start: undefined,
            end: [],
            way: L.featureGroup(),
            points: []
        };

        if (this._map instanceof Maps) {
            return this._route.get(this._map.get()._id) || defaults;
        } else {
            return this._route || defaults;
        }
    }

    setRoute (route) {
        if (this._map instanceof Maps) {
            this._route.set(this._map.get()._id, route);
        } else {
            this._route = route;
        }
    }

    hasPoint (latlng) {
        const route = this.getRoute();

        if (route.start) {
            if (route.start.getLatLng().equals(latlng)) {
                return true;
            }
        }
        if (route.end) {
            return _.has(route.end, marker => marker.getLatLng().equals(latlng));
        }
        return false;
    }

    showCoordinates (e) {
        bootbox.dialog({
            title: '<i class="fa fa-crosshairs"></i> Coordenadas',
            message: `
                <textarea id=\"clipboard-target\" readonly>${e.latlng.lat}, ${e.latlng.lng}</textarea>
            `,
            backdrop: false,
            buttons: {
                main: {
                    label: '<i class="fa fa-times"></i> Fechar',
                    className: 'btn-default'
                },
                info: {
                    label: '<i class="fa fa-clipboard"></i> Copiar',
                    className: 'btn-info',
                    callback () {
                        const copyTextarea = document.querySelector('#clipboard-target');
                        copyTextarea.select();
                        try {
                            const successful = document.execCommand('copy');
                            const msg = successful ? 'successful' : 'unsuccessful';
                            console.log(`Copying text command was ${msg}`);
                        } catch (err) {
                            console.log('Oops, unable to copy');
                        }
                    }
                }
            }
        });
    }

    centerMap (e) {
        return this._map.panTo(e.latlng);
    }

    zoomIn () {
        return this._map.zoomIn();
    }

    zoomOut () {
        return this._map.zoomOut();
    }

    removePoints () {
        const route = this.getRoute();

        if (this._map.hasLayer(route.start)) { this._map.removeLayer(route.start); }
        route.start = undefined;

        if (route.end.length > 0) { _.forEach(route.end, marker => this._map.removeLayer(marker)); }
        route.end = [];

        this.setRoute(route);
        this._removeLegend();
        route.way.clearLayers();
    }

    redraw () {
        const route = this.getRoute();
        route.way.clearLayers();
        this._removeLegend();
        this._drawRoute();
    }

    active () {
        return !!this.getRoute().start;
    }

    screenshot () {
        return capture().get();
    }

    setStartPosition (e, isDraw = true) {
        const route = this.getRoute();
        if (route.start) {
            route.start.setLatLng(e.latlng);
        } else {
            route.start = this._createMarker(e, this.options.startMarkerIcon, this.options.startMarkerLabel);
            route.start.on('dragend', () => {
                this._drawRoute();
            });
            route.start.on('click', () => {
                this._showMarkerActions(route.start, 'startPoint');
                route.start.hasBubble = true;
            });
        }
        if(isDraw){
            this.setRoute(route);
            this._drawRoute();
        }
    }

    setEndPosition (e, isDraw = true) {
        const route = this.getRoute();
        const marker = this._createMarker(e, this.options.endMarkerIcon, this.options.endMarkerLabel);

        marker.on('dragend', () => {
            this._drawRoute();
        });
        marker.on('click', () => {
            this._showMarkerActions(marker, 'endPoint');
        });

        if (route.end.length > 5) {
            const rmarker = route.end.shift();
            this._map.removeLayer(rmarker);
        }

        route.end.push(marker);
        if(isDraw){
            this.setRoute(route);
            this._drawRoute();
        }
    }

    createPOI (e) {
        LayerInfo('CreatePoint').addMarker(e.latlng);
        api.general.get.geocode({
            lat: e.latlng.lat,
            lng: e.latlng.lng
        }).then(loc => {
            loc.coordinates.lat = e.latlng.lat;
            loc.coordinates.lng = e.latlng.lng;
            LayerInfo('CreatePoint').updateByGeocode(loc);
        });
    }

    setMap (map) {
        this._map = map;
    }

    _createMarker (e, icon, label) {
        L.Marker.include(L.Mixin.ContextMenu);
        const marker = L.marker(e.latlng, {
            draggable: true,
            icon,
            zIndexOffset: 99999,
            contextmenu: true,
            contextmenuItems: [{
                text: label,
                index: 0
            }, {
                separator: true,
                index: 1
            }]
        });
        this._map.addLayer(marker);
        return marker;
    }

    _drawRoute () {
        const route = this.getRoute();

        if (!route.start || route.end.length === 0) return;

        if (this._map.hasLayer(route.way)) { route.way.clearLayers(); }

        route.points = [];
        this.setRoute(route);

        _.forEach(route.end, m => {
            const origin = `${route.start.getLatLng().lat}, ${route.start.getLatLng().lng}`;
            const destination = `${m.getLatLng().lat}, ${m.getLatLng().lng}`;
            this._calcRoute(origin, destination);
        });
    }

    _createLegend () {
        const route = this.getRoute();

        this._removeLegend();
        route.legend = L.control({ position: 'bottomleft' });
        route.legend.onAdd = (map) => {
            const div = L.DomUtil.create('div', 'layer-legend');
            div.innerHTML = '<div class="legend-title">Rota(s)</div>';
            div.innerHTML += route.points.join('');
            return div;
        };
        this._map.addControl(route.legend);
    }

    _removeLegend () {
        const route = this.getRoute();
        if (route.legend) {
            this._map.removeControl(route.legend);
            route.legend = null;
        }
    }

    _showMarkerActions (marker, type) {
        if (halo().hasBubbles(marker._leaflet_id)) return;
        return halo().create([{
            check () {
                return false;
            },
            icon: 'icon_bubble_trash',
            layer: marker,
            click: () => {
                const route = this.getRoute();
                if (type === 'startPoint') {
                    this._map.removeLayer(marker);
                    route.start = undefined;
                } else {
                    _.forEach(route.end, (m, index) => {
                        if (marker && marker.getLatLng().equals(m.getLatLng())) {
                            this._map.removeLayer(marker);
                            marker = null;
                            route.end.splice(index, 1);
                        }
                    });
                }
                this.setRoute(route);
                this.redraw();
            },
            position: 'top',
            title: 'Excluir'
        },
        ...(type ==="endPoint" ? [{
                            check () {
                                return false;
                            },
                            icon: 'icon_bubble_change',
                            layer: marker,
                            click: () => {
                                const route = this.getRoute();
                                const temp = _.cloneDeep(route);

                                if (type === 'startPoint') {
                                    this._map.removeLayer(marker);
                                    route.start = undefined;
                                } else {
                                    _.forEach(temp.end, (m, index) => {
                                        if (marker && marker.getLatLng().equals(m.getLatLng())) {
                                            this._map.removeLayer(marker);
                                            route.end.splice(index, 1);

                                            const s = { latlng: m.getLatLng() };
                                            const e = { latlng: route.start.getLatLng() };
                                            this.setEndPosition(e, false);
                                            this.setStartPosition(s, false);

                                        }
                                    });
                                }
                                this.setRoute(route);
                                this.redraw();
                            },
                            position: 'top',
                            title: translate('Action.ReverseRoute')
                        }] : [])
        ], {
            radius: 50,
            offset: [0, 35]
        });
    }
}

class Google extends Directions {
    _getWays (data) {
        if (!data.routes) return;

        const colors = ['#3498DB', '#E74C3C', '#2ECC71', '#F1C40F', '#9B59B6'];
        return _.map(data.routes, (routing, index) => {
            const route = {
                path: [],
                distance: routing.legs[0].distance.text,
                color: colors[index]
            };

            _.forEach(routing.legs[0].steps, step =>
                _.forEach(L.PolylineUtil.decode(step.polyline.points), (path) => {
                    const linePath = new L.LatLng(path[0], path[1]);
                    return route.path.push(linePath);
                })
            );

            return route;
        });
    }

    _calcRoute (origin, destination) {
        const directionsService = new google.maps.DirectionsService();
        const request = {
            origin,
            destination,
            travelMode: google.maps.TravelMode.DRIVING,
            provideRouteAlternatives: false,
            region: 'PT-BR'
        };

        directionsService.route(request, (response, status) => {
            if (status !== 'OK') return;

            const route = this.getRoute();
            const ways = this._getWays(response);

            if (ways) {
                const colors = ['#3498DB', '#E74C3C', '#2ECC71', '#F1C40F', '#9B59B6'];
                if (!this._map.hasLayer(route.way)) {
                    this._map.addLayer(route.way);
                }
                _.forEach(ways, (way) => {
                    route.way.addLayer(L.polyline(way.path, {
                        color: colors[route.points.length],
                        opacity: 0.9,
                        lineJoin: 'round'
                    }).bindTooltip(way.distance));
                    const legendLabel = `<div class=\"legend-item\"><div class=\"legend-rect\" style=\"background-color:${colors[route.points.length]}\"></div><div class=\"legend-text\">${way.distance}</div></div>`;
                    route.points.push(legendLabel);
                });

                this.setRoute(route);
                this._createLegend();
            }
        });
    }

    streetView (e) {
        return streetView().show(e.latlng);
    }
}

export default {
    Google
};



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/Directions.js